import { Component, OnDestroy, OnInit, inject } from '@angular/core';
import { humanReadableRegistrationStatus, PhoneResource } from '../../../../shared/resources/phone.resource';
import { DeviceRegistrationStatus } from '../../../../shared/models/generated/ziroModels';
import { PhoneUiContext } from '../../../../shared/phone-buttons/contexts/phone-ui.context';
import { SiteContext } from '../../../shared/contexts/site.context';
import { SiteSummaryContext } from '../../../../shared/contexts/site-summary.context';
import { combineLatest, Subscription } from 'rxjs';
import { ZiroIcons } from '../../../../shared/models/ziro-icons.enum';

@Component({
  selector: 'ziro-public-phone-contact-card',
  templateUrl: './public-phone-contact-card.component.html',
  styleUrls: ['./public-phone-contact-card.component.scss'],
  standalone: false,
})
export class PublicPhoneContactCardComponent implements OnInit, OnDestroy {
  private phoneResource = inject(PhoneResource);
  private phoneUiContext = inject(PhoneUiContext);
  private siteContext = inject(SiteContext);
  private siteSummaryContext = inject(SiteSummaryContext);

  ziroIcons = ZiroIcons;
  DeviceRegistrationStatus = DeviceRegistrationStatus;
  humanReadableRegistrationStatus = humanReadableRegistrationStatus;

  siteName: string;
  phoneName: string;
  phoneDescription: string;
  phoneRegistrationStatus: DeviceRegistrationStatus;
  phoneRegistrationStatusIconClass: string;

  private _cucmServerId: number;
  private _subscription = new Subscription();

  ngOnInit(): void {
    const subs = combineLatest([
      this.siteSummaryContext.state$,
      this.siteContext.state$,
      this.phoneUiContext.phoneState$,
    ]).subscribe(([siteSummary, site, phone]) => {
      this.siteName = site.name;
      this._cucmServerId = this.siteSummaryContext.findCucmServerIdForSite(siteSummary, Number(site.id));
      this.phoneDescription = phone.description;

      if (this.phoneName !== phone.name) {
        if (phone.name && /^(SEP|SIP)[a-fA-F0-9]{12}$/.test(phone.name)) {
          this.phoneName = phone.name;
          this._updatePhoneRegistrationStatus();
        } else {
          this.phoneName = '';
          this.phoneRegistrationStatus = null;
        }
      }
    });
    this._subscription.add(subs);
  }

  ngOnDestroy(): void {
    this._subscription.unsubscribe();
  }

  private setRegistrationStatusIconClass(): void {
    if (this.phoneRegistrationStatus === DeviceRegistrationStatus.REGISTERED) {
      this.phoneRegistrationStatusIconClass = `icon-success ${this.ziroIcons.CIRCLE_CHECK_OUTLINE}`;
    } else if (this.phoneRegistrationStatus === DeviceRegistrationStatus.NOT_FOUND) {
      this.phoneRegistrationStatusIconClass = `icon-warning ${this.ziroIcons.WARNING_TRIANGLE}`;
    } else if (this.phoneRegistrationStatus === DeviceRegistrationStatus.UNREGISTERED) {
      this.phoneRegistrationStatusIconClass = `icon-danger ${this.ziroIcons.WARNING_TRIANGLE}`;
    } else {
      this.phoneRegistrationStatusIconClass = '';
    }
  }

  private _updatePhoneRegistrationStatus(): void {
    this.phoneRegistrationStatus = null;
    this.phoneResource.getPhoneStatus(this.phoneName, this._cucmServerId).subscribe((status) => {
      this.phoneRegistrationStatus = status.status;
      this.setRegistrationStatusIconClass();
    });
  }
}
